const environments = {
    development: {
        host: 'https://dev.dynamichealth.today',
        login: 'https://dev.dynamichealth.today'
    },
    local: {
        host: 'http://localhost/DynamicHealthApp',
        login: 'http://localhost/DynamicHealthApp'
    },
    uat: {
        host: 'https://uatapp.dynamichealth.today',
        login: 'https://uatapp.dynamichealth.today'
    },
    production: {
        host: 'https://app.dynamichealth.today',
        login: 'https://dynamichealth.today'
    }
};

/**
 * Which environment this bundle talks to, chosen at build time.
 *
 * This was previously a hardcoded `export default config.uat`, which meant the
 * production quiz wrote every client's answers into the UAT database while
 * redirecting the client back to production, so production never saw them.
 *
 *   npm run build                              -> production
 *   npm run build:dev                          -> development
 *   REACT_APP_QUIZ_ENV=uat npm run build       -> uat
 *   REACT_APP_QUIZ_ENV=local npm start         -> local
 */
const selectedEnvironment = process.env.REACT_APP_QUIZ_ENV
    ?? process.env.REACT_APP_ENV
    ?? (process.env.NODE_ENV === 'production' ? 'production' : 'development');

const environment = environments[selectedEnvironment] ?? environments.production;

/**
 * Shared secret for POST /api/quiz, which fails closed without it.
 *
 * Default comes from `.env`. Override at build time, or in `.env.local`,
 * to the same value as QUIZ_API_SECRET in the target app's .env. A value
 * compiled into a browser bundle is readable by anyone who opens the JS,
 * so this gates casual access only; a short-lived token minted by the app
 * when it opens the quiz would be the stronger fix.
 */
const quizSecret = process.env.REACT_APP_QUIZ_SECRET ?? '';

if (quizSecret === '') {
    console.warn('[CONFIG] REACT_APP_QUIZ_SECRET is not set: POST /api/quiz will be rejected with 403.');
}

export default {
    ...environment,
    environment: selectedEnvironment,
    quizSecret
};
